import React from 'react';

const NotificationContext = React.createContext();

/* Prevent circular dependencies - webpack messes up the context api otherwise */
export default NotificationContext;
